const ESTADOS = {
    new: "Nueva",
    open: "Registrada",
    pending: "Pendiente",
    hold: "En espera"
}
export default function getEstadoDesc (estado) {
    return ESTADOS[estado] || "Resuelto";
}